import { ElMessageBox } from 'element-plus';

function showConfirm(message, title = '확인', options = {}) {
  if (message && typeof message === 'object') {
    const normalized = message;
    message = normalized.content || normalized.message || '';
    title = normalized.title || title;
    options = normalized;
  }

  return ElMessageBox.confirm(message, title, {
    confirmButtonText: '확인',
    cancelButtonText: '취소',
    type: 'warning',
    ...options
  });
}

export function ConfirmModel() {
  this.$confirm = showConfirm;
  return this;
}

export default {
  install(app) {
    app.config.globalProperties.$confirm = showConfirm;
  }
};
